// extracted by mini-css-extract-plugin
module.exports = {"window-content":"Modal_window-content__1XDUg","message":"Modal_message__3Rgue","buttonBlock":"Modal_buttonBlock__3Yied"};